import React from 'react'
import BancoPanLogoMarine from '../../assets/images/marine-banco-pan-logo/marine@3x.png'
import MarcaAlelo from '../../assets/images/marca-alelo-blue.png'
import './style.scss'

export default function Footer() {
    return (
        <footer>
            <div className="logo">
            <a href="https://veloe.com.br/" target="_blank"><img width="76px" heigth="32px" src={BancoPanLogoMarine} alt="Veloe Logo" /></a>
            </div>
            <div className="inform">
                <p>© Todos os direitos reservados - Veloe 2021</p>
                <div className="section-logoElo">
                    <img height="25px" alt="Uma marca alelo" src={MarcaAlelo} />
                </div>
            </div>
        </footer>
    )
}